import React from "react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import {
  selectFilterAttendanceHistory,
  selectFilterChapterInvolvement,
  selectFilterCommitteeCredit,
  selectFilterNegative,
  selectFilterPayment,
  selectFilterSocials,
  selectFilterVivo,
  selectFilterWorkshops,
  setFilterAttendanceHistory,
  setFilterChapterInvolvement,
  setFilterCommitteeCredit,
  setFilterNegative,
  setFilterPayment,
  setFilterSocials,
  setFilterVivo,
  setFilterWorkshops,
} from "../../../features/search/slice";
function FilterInput({
  type = "text",
  placeholder = "",
  value = "",
  onChange = () => {},
}) {
  return (
    <Form.Group controlId="vivoInput">
      <Form.Control
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event)}
      />
    </Form.Group>
  );
}

export default FilterInput;

export const CommitteeCreditFilterInput = connect(
  (state) => {
    const value = selectFilterCommitteeCredit(state);
    return {
      value,
      placeholder: "Committee Credit",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterCommitteeCredit(event.target.value));
      },
    };
  }
)(FilterInput);

export const AttendanceHistoryFilterInput = connect(
  (state) => {
    const value = selectFilterAttendanceHistory(state);
    return {
      value,
      placeholder: "Attendance Credit",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterAttendanceHistory(event.target.value));
      },
    };
  }
)(FilterInput);

export const VivoFilterInput = connect(
  (state) => {
    const value = selectFilterVivo(state);
    return {
      value,
      placeholder: "Vivo Credit",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterVivo(event.target.value));
      },
    };
  }
)(FilterInput);

export const SocialsFilterInput = connect(
  (state) => {
    const value = selectFilterSocials(state);
    return {
      value,
      placeholder: "Social Credit",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterSocials(event.target.value));
      },
    };
  }
)(FilterInput);

export const WorkShopsFilterInput = connect(
  (state) => {
    const value = selectFilterWorkshops(state);
    return {
      value,
      placeholder: "Workshop Credit",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterWorkshops(event.target.value));
      },
    };
  }
)(FilterInput);

export const NegativeFilterInput = connect(
  (state) => {
    const value = selectFilterNegative(state);
    return {
      value,
      placeholder: "Negative One",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterNegative(event.target.value));
      },
    };
  }
)(FilterInput);

export const PaymentFilterInput = connect(
  (state) => {
    const value = selectFilterPayment(state);
    return {
      value,
      placeholder: "Scholarship Dues",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterPayment(event.target.value));
      },
    };
  }
)(FilterInput);

export const ChapterInvolvementFilterInput = connect(
  (state) => {
    const value = selectFilterChapterInvolvement(state);
    return {
      value,
      placeholder: "Fundraiser credit",
      type: "number",
    };
  },
  (dispatch) => {
    return {
      onChange: (event) => {
        dispatch(setFilterChapterInvolvement(event.target.value));
      },
    };
  }
)(FilterInput);
